module.exports = __webpack_public_path__ + "img/Mina-La-Puerta.83bcd3a8.png";